<template>
  <div class="warn">
    <div class="content">
      <span>{{params[type].text}}</span>
      <span style="color: #3f86de;cursor: pointer;" @click="clickRouter">{{params[type].router}}</span>
    </div>
  </div>
</template>

<script>
  import CryptoJS from 'crypto-js'
  import { checkScan } from '../common/Axios.js'
  import uploadWebEvent from '../common/UploadWebEvent.js'
  import { getLocationHash } from '../common/Common.js'
  export default {
    data () {
      return {
        params: {
          // 账号不存在
          'accountnotexist': {
            text: 'The account does not exist, want to ',
            router: 'creat a new account?',
            fn: function () {
              uploadWebEvent('SIGNIN_ACCOUNT_NOT_EXIST_TO_SIGNUP') // 埋点统计：从账号不存在提示跳转到注册页面
              return {path: '/login/signup', query: {'account': this.data}}
            }.bind(this)
          },
          // 账号存在
          'accountexist': {
            text: 'The account already exists, want to ',
            router: 'sign in?',
            fn: async function () {
              uploadWebEvent('SIGNUP_ACCOUNT_EXIST_TO_SIGNIN') // 埋点统计：从账号已存在提示跳转到登录页面
              let publicKey = localStorage.getItem(this.data + '_publickey') || ''
              let keyMd5 = CryptoJS.MD5(publicKey).toString().substr(8, 16)
              let route = {
                query: {
                  account: this.data,
                  countryCode: '',
                  showTip: true
                }
              }
              // 检测是否需要扫码
              let res = await checkScan(route, {account: this.data, key_md5: keyMd5}, '', getLocationHash())
              if (res.path === '/login/password') {
                res['path'] = '/login/signin'
              }
              return res
            }.bind(this)
          }
        }
      }
    },
    props: ['type', 'data'],
    mounted () {
    },
    methods: {
      async clickRouter () {
        let res = await this.params[this.type].fn()
        this.$router.push(res)
      }
    }
  }
</script>

<style lang="scss" scoped>
	.warn {
    width: 300px;
    height: 55px;
    margin: 0 auto;
    background: #f5f7fa;
    border: 1px solid #eeeeee;
    border-radius: 0 0 2px 2px;
    .content {
      font-size: 12px;
      width: 200px;
      height: 55px;
      line-height: 20px;
      text-align: center;
      margin: 7px auto;
      color: #939699;
    }
  }
</style>



// WEBPACK FOOTER //
// Warn.vue?79f8f8e6